/**
 * Stores build information about <b>this specific version of the `ruffle-core` library</b>.
 *
 * It does not represent the version of Ruffle that may be in use by the page (for example, if a browser extension overrides it).
 *
 * @privateRemarks
 * This is generated at build time via `set_version.ts`.
 */
export const buildInfo = {
    versionNumber: "0.2.0-nightly.2026.2.3",
    versionName: "0.2.0-nightly.2026.2.3",
    versionChannel: "nightly",
    buildDate: "2026-02-03T00:12:54.612Z",
    commitHash: "ce0f2a0aa38bd9071f7d0312d8800a6b4737c30f",
};
